import { MESApiService, spParameter } from "@dexteel/mesf-core";

export const getMechanicalSamples = async (
	heatId: number,
	statusCode: string | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "HeatId", value: heatId });
	parameters.push({ name: "StatusCode", value: statusCode });

	return await apiService.callV2("[LAB].[GetMechanicalSamples]", parameters);
};
